module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.question.typeQuestion == 'radio' || _vm.question.typeQuestion == 'multichoice') ? _c('div', {
    staticClass: "exercise-item text-left"
  }, [(_vm.labelColors && _vm.question.typeQuestion == 'radio') ? _c('div', {
    staticClass: "exercise-body"
  }, [_c('div', {
    staticClass: "text-left"
  }, _vm._l((_vm.question.answers), function(answer, index) {
    return _c('div', {
      key: answer.guid,
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "radioBoxes",
      class: {
        'ellipsis': _vm.showEllipsis
      },
      on: {
        "click": function($event) {
          _vm.showEllipsis = !_vm.showEllipsis
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "100px",
        "text-align": "right"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#b1b1b1"
      }
    }, [_vm._v("\n                  ("), (_vm.results.reduce(function (a, c) { return a + c; }, 0) != 0) ? _c('span', [_vm._v(_vm._s(Math.round(_vm.results[index] / _vm.results.reduce(function (a, c) { return a + c; }, 0) * 100 * 100) / 100))]) : _c('span', [_vm._v("0")]), _vm._v("%  = " + _vm._s(_vm.results[index]) + " / " + _vm._s(Math.round(100 * _vm.results.reduce(function (a, c) { return a + c; }, 0)) / 100) + " )\n                ")])]), _vm._v(" "), (answer.correct) ? _c('div', {
      staticStyle: {
        "display": "inline-block",
        "background-color": "#4aa362",
        "border-radius": "5px"
      },
      style: ({
        width: (3 * Math.round(_vm.results[index] / _vm.results.reduce(function (a, c) { return a + c; }, 0) * 100 * 100) / 100 + 3) + 'px'
      })
    }, [_c('span', {
      staticStyle: {
        "color": "#4aa362"
      }
    }, [_vm._v("|")])]) : _c('div', {
      staticStyle: {
        "display": "inline-block",
        "background-color": "#da7162",
        "border-radius": "5px"
      },
      style: ({
        width: (3 * Math.round(_vm.results[index] / _vm.results.reduce(function (a, c) { return a + c; }, 0) * 100 * 100) / 100 + 3) + 'px'
      })
    }, [_c('span', {
      staticStyle: {
        "color": "#da7162"
      }
    }, [_vm._v("|")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.pickTranslation(answer.text))
      }
    })])])
  }), 0)]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-869cea14", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-869cea14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exercises/ExerciseResultsPreview.vue
// module id = 1423
// module chunks = 1